var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashWhiteGrayBgRoundedBorderLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 3.5,
    fill: "#9296AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 3.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3193 7.1875C11.1454 7.1875 10.9797 7.25595 10.8583 7.3761C10.7371 7.49608 10.67 7.65766 10.67 7.825V8.4625H14.3298V7.825C14.3298 7.65766 14.2627 7.49608 14.1415 7.3761C14.0201 7.25595 13.8544 7.1875 13.6805 7.1875H11.3193ZM15.3923 8.4625V7.825C15.3923 7.3724 15.2106 6.93943 14.889 6.62104C14.5676 6.30282 14.1327 6.125 13.6805 6.125H11.3193C10.8671 6.125 10.4322 6.30282 10.1108 6.62104C9.7892 6.93943 9.60754 7.3724 9.60754 7.825V8.4625H7.71875C7.42535 8.4625 7.1875 8.70035 7.1875 8.99375C7.1875 9.28715 7.42535 9.525 7.71875 9.525H7.83671V17.175C7.83671 17.6276 8.01837 18.0606 8.33997 18.379C8.6614 18.6972 9.09622 18.875 9.54851 18.875H15.4513C15.9036 18.875 16.3384 18.6972 16.6598 18.379C16.9814 18.0606 17.1631 17.6276 17.1631 17.175V9.525H17.2812C17.5747 9.525 17.8125 9.28715 17.8125 8.99375C17.8125 8.70035 17.5747 8.4625 17.2812 8.4625H15.3923ZM8.89921 9.525V17.175C8.89921 17.3423 8.9663 17.5039 9.08749 17.6239C9.20886 17.7441 9.37459 17.8125 9.54851 17.8125H15.4513C15.6252 17.8125 15.7909 17.7441 15.9123 17.6239C16.0335 17.5039 16.1006 17.3423 16.1006 17.175V9.525H8.89921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhiteGrayBgRoundedBorderLightBlue);
export default __webpack_public_path__ + "static/media/trashWhiteGrayBgRoundedBorderLightBlue.81f830d5718bc21d10ecba65262efe6c.svg";
export { ForwardRef as ReactComponent };